import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { zip } from 'rxjs';
import { InputDialogData } from 'src/app/common/model/input-dialog-data';
import { FormFieldElement } from 'src/app/shared/model/form-field-element';

@Component({
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.scss']
})
export class InputDialogComponent {

  form: FormGroup;

  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  formField: FormFieldElement;

  constructor(public dialogRef: MatDialogRef<InputDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: InputDialogData,
              public translate: TranslateService, private formBuilder: FormBuilder) {
    this.formField = this.data.formFieldElement;
    this.createForm();
    zip(
      this.translate.get(data.title || ''),
      this.translate.get(data.message || ''),
      this.translate.get(data.confirmText || 'ok'),
      this.translate.get(data.cancelText || 'cancel')
    ).subscribe(
      ([title, message, confirmation, cancel]: [string, string, string, string]) => {
        this.title = title;
        this.message = message;
        this.confirmText = confirmation;
        this.cancelText = cancel;
      }
    );
  }

  private createForm(): void {
    const form = this.formBuilder.group({});
    const validators = this.formField.validators?.map(validator => validator.validator) || [];
    form.addControl(
      this.formField.name,
      new FormControl({ value: this.formField.defaultValue !== null ? this.formField.defaultValue : null, disabled: this.formField.disabledOnNew },
        validators)
        );
    this.form = form;
  }

}
